module.exports = __webpack_public_path__ + "static/media/data-access-api-icon.d2fcc2c5.svg";